import {
  collection,
  selection,
} from 'common/store/actions';

export const NAMESPACE = 'METERING_PROFILES';

const collectionActions = collection.factory(NAMESPACE);
const selectionActions = selection.factory(NAMESPACE);

export const {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
  TOGGLE_SORT,
  PAGINATION_CHANGE,
  SEARCH,
} = collectionActions.TYPES;

export const {
  SET_SELECTED,
  CLEAR_SELECTED,
} = selectionActions.TYPES;

export const {
  setSelected,
  clearSelected,
} = selectionActions;

export const {
  load,
  loadSuccess,
  loadError,
  toggleSort,
  update,
  search,
  paginationChange,
} = collectionActions;
